<template>
  <div class="row justify-content-center mt-3 mt-lg-4" v-if="totalPages > 1">
    <div class="col-12 col-lg-auto">
      <nav
        class="pagination"
        role="navigation"
        aria-label="Paginatie navigatie"
      >
        <button
          type="button"
          class="pagination__item"
          :class="{ 'pagination__item--disabled': currentPage === 1 }"
          :disabled="currentPage === 1 || loading"
          @click="goToPrevious"
          aria-label="Vorige pagina"
        >
          <i class="icon icon-arrow icon--rotate-half"></i>
        </button>

        <template v-for="page in visiblePages" :key="page">
          <span
            v-if="page === '...'"
            class="pagination__ellipsis"
            aria-hidden="true"
          >
            ...
          </span>
          <button
            v-else
            type="button"
            class="pagination__item"
            :class="{ 'pagination__item--active': page === currentPage }"
            :disabled="loading"
            @click="goToPage(page)"
            :aria-label="`Ga naar pagina ${page}`"
            :aria-current="page === currentPage ? 'page' : undefined"
          >
            {{ page }}
          </button>
        </template>

        <button
          type="button"
          class="pagination__item"
          :class="{ 'pagination__item--disabled': currentPage === totalPages }"
          :disabled="currentPage === totalPages || loading"
          @click="goToNext"
          aria-label="Volgende pagina"
        >
          <i class="icon icon-arrow"></i>
        </button>
      </nav>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Pagination',
  props: {
    currentPage: {
      type: Number,
      required: true,
      default: 1,
    },
    totalPages: {
      type: Number,
      required: true,
      default: 1,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    maxVisiblePages: {
      type: Number,
      default: 5,
    },
  },
  emits: ['page-changed'],
  computed: {
    visiblePages() {
      const total = this.totalPages;
      const current = this.currentPage;
      const max = this.maxVisiblePages;

      if (total <= max + 2) {
        return Array.from({ length: total }, (_, i) => i + 1);
      }

      const pages = [];
      const halfMax = Math.floor(max / 2);

      pages.push(1);

      if (current <= halfMax + 2) {
        for (let i = 2; i <= max; i++) {
          pages.push(i);
        }
        pages.push('...');
        pages.push(total);
      } else if (current >= total - halfMax - 1) {
        pages.push('...');
        for (let i = total - max + 1; i <= total; i++) {
          if (i > 1) pages.push(i);
        }
      } else {
        // In het midden
        pages.push('...');
        for (
          let i = current - Math.floor(max / 2) + 1;
          i <= current + Math.floor(max / 2) - 1;
          i++
        ) {
          pages.push(i);
        }
        pages.push('...');
        pages.push(total);
      }

      return pages;
    },
  },
  methods: {
    goToPage(page) {
      if (page === '...' || page === this.currentPage || this.loading) {
        return;
      }
      this.$emit('page-changed', page);
    },
    goToPrevious() {
      if (this.currentPage > 1 && !this.loading) {
        this.$emit('page-changed', this.currentPage - 1);
      }
    },
    goToNext() {
      if (this.currentPage < this.totalPages && !this.loading) {
        this.$emit('page-changed', this.currentPage + 1);
      }
    },
  },
};
</script>
